import type GetAllOrdersDTO from '../../repositories/order/dto/getAll.dto'
import type { GetOrderDTO } from '../../repositories/order/dto/getOrder.dto'
import type { OrderRepository } from '../../repositories/order/order.repository'
import type CreateOrderDTO from '../../repositories/order/dto/createOrder.dto'
import type {
  ChanelActionType,
  IncomingMessagePayload,
  OrderWSUpdate,
  RepositoryWS
} from "@trading/infrastructure";
import type UpdateOrderDTO from "../../repositories/order/dto/updateOrder.dto";

export default class OrdersController {
  constructor(
    private orderRepository: OrderRepository,
    private orderRepositoryWs?: RepositoryWS<IncomingMessagePayload<OrderWSUpdate>>
  ) {
  }

  async getAllOrders(dto: GetAllOrdersDTO) {
    return await this.orderRepository.getAll(dto)
  }

  async getOneOrder(dto: GetOrderDTO) {
    return await this.orderRepository.get(dto)
  }

  async createOrder(dto: CreateOrderDTO) {
    return await this.orderRepository.create(dto)
  }

  async updateOrder(dto: UpdateOrderDTO, id: number) {
    return await this.orderRepository.update(dto, id)
  }

  async closeOrder(id: ID) {
    return await this.orderRepository.delete(id)
  }

  async cancelOrdersBySymbol(symbol: string): Promise<number> {
    return await this.orderRepository.deleteBySymbol(symbol)
  }

  async subscribeToOrdersChannel(
    actionName: ChanelActionType,
    cb: (order: IncomingMessagePayload<OrderWSUpdate>) => void
  ): Promise<undefined | CallableFunction> {
    if (!this.orderRepositoryWs || typeof this.orderRepositoryWs.subscribeToChannelsAction !== 'function') return
    return await this.orderRepositoryWs.subscribeToChannelsAction(actionName, cb)
  }
}
